import React, { Component } from 'react';
import Modal from 'react-modal';

import Analytics from 'APP_ROOT/services/analytics';
import Events from '../../common/events';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import { strings } from '../../../localization';

export default class RemoveSharedRavenModal extends Component {

    constructor(props) {

        super(props);

        this.state = {
            errorMessage: null,
        };
    }

    componentDidUpdate() {

        if (this.props.removeSharedRavenModalOpen) document.documentElement.classList.add("no-scroll");
    }

    afterRemoveSharedRavenModalOpened = (e) => {
        Analytics.modalView('/removeSharedRavenModal');
        this.setState({
            errorMessage: null
        });
    }

    removeSharedRaven = (e) => {

        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.shared_raven_removing) } }));
        var ravenUuid = this.props.raven.ravenUuid;
        LambdaUtil.removeSharedRavenAccess(this.props.user.stage, ravenUuid, null, this.onRemoveSharedRavenSuccess, this.onRemoveSharedRavenFail);
    }

    onRemoveSharedRavenSuccess = (data) => {

        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            this.genericError(data);
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            return;
        } else {
            document.documentElement.classList.remove("no-scroll");
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.shared_raven_remove_success), style: 'success', override: true } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
            return;
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onRemoveSharedRavenFail = (data) => {

        this.genericError(data);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    genericError(data) {

        if (data) console.error(data);
        this.setState({
            errorMessage: strings.formatString(strings.raven_share_error_generic)
        })
    }

    render() {

        return (
            <Modal isOpen={this.props.removeSharedRavenModalOpen}
                contentLabel="edit-plan-modal"
                className="react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onRequestClose={this.props.closeRemoveSharedRavenModal}
                onAfterOpen={this.afterRemoveSharedRavenModalOpened}>

                <div className="container-fluid form-card">

                    <h2><i className="material-icons">remove_circle_outline</i>{strings.formatString(strings.raven_share_remove_confirm_title)}</h2>
                    <p>{strings.formatString(strings.raven_share_confirm_message)}</p>
                    <div className="row">
                        <div className="col-12 action-btns text-right">
                            <button className="btn btn-outline-blue" onClick={this.props.closeRemoveSharedRavenModal}><i className="material-icons">close</i>{strings.formatString(strings.app_cancel)}</button>
                            <button className="btn" onClick={this.removeSharedRaven}><i className="material-icons">remove_circle_outline</i>{strings.formatString(strings.raven_share_remove_confirm, this.props.raven.vehicle.name)}</button>

                            <div>{(this.state.errorMessage) ? (<p className="error-message"><i className="material-icons">error_outline</i><span>{this.state.errorMessage}</span></p>) : null}</div>
                        </div>
                    </div>

                </div>
            </Modal>
        );
    }
}
